module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_1.398674d2.jpg";